<div 
     class="container"
     [class.group]="isGroup"
     [class.favorite]="isGroup && favorite"
     [class]="size"
     >
     <img
          *ngIf="data?.avatar_url"
          [src]="data?.avatar_url"
          (error)="imageError()">

     <div></div>
</div>
